import DBModal from 'components/modal/modal';
import styles from './news.module.scss';

// DBModal sized to the screen: a tall window scrolls inside, with its title
// and its buttons kept in view, instead of running off the page.
const NewsModal = ({isOpen, onClose, width, children}) => (
  <DBModal
    isOpen={isOpen}
    handleClose={onClose}
    destroyOnClose
    width={width}
    className={styles.scrollModal}
    content={children}
  />
);

export default NewsModal;
